export type VisibilityTargetType = 'ORG' | 'PEOPLE' | 'ROLE' | 'USER';

export function selectionKey(targetType: VisibilityTargetType | string, targetId: string) {
  return `${targetType}:${targetId}`;
}
